import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from 'stores/store';

interface AuthGuardProps {
	children: React.ReactNode;
	type?: 'register' | 'dashboard';
}

const AuthGuard = ({ type = 'dashboard', children }: AuthGuardProps) => {
	const admin = useSelector((state: RootState) => state.admin);

	if (!admin) {
		return type === 'register' ? <Navigate to="/register" /> : <Navigate to="/" />;
	}

	return <>{children}</>;
};

export default AuthGuard;
